import React from 'react';
import './RegionPill.css';

interface RegionPillProps {
  region: string | null;
}

const RegionPill: React.FC<RegionPillProps> = ({ region }) => (
  <span className="region-pill">{region ?? '—'}</span>
);

export default RegionPill;
